/*
 * TestTypeDetails Messages
 *
 * This contains all the text for the TestTypeDetails component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.TestTypeDetails';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
});
